<main @fade *ngIf="permissionDenied===false">
  <nb-card [nbSpinner]="loading">
    <nb-card-header *ngIf="!isModal && !editMode" i18n="@@Creating"><a [routerLink]="absolutePath">{{ title }}</a> / Добавление</nb-card-header>
    <nb-card-header *ngIf="!isModal && editMode" i18n="@@Updating"><a [routerLink]="absolutePath">{{ title }}</a>
      <span *ngIf="editName">  / {{ editName }}  </span>
    </nb-card-header>

    <nb-card-header *ngIf="deleted"><span i18n="@@RecordDeletedNoTags" class="badge text-bg-secondary">запись удалена</span>
      &nbsp;
      <button *ngIf="deleted" (click)="restore()" i18n-nbTooltip="@@Restore" nbTooltip="Восстановить" nbButton status="control" size="small">
        <nb-icon icon="repeat-outline"/>
      </button>
    </nb-card-header>

    <nb-card-body>
      <div [ngClass]="isModal ? '' : 'row'">
        <div [ngClass]="isModal ? '' : 'col-lg-7 n-part-left'">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <formly-form [form]="form" [fields]="fields" [options]="options" [model]="model"></formly-form>

            <button nbButton status="primary" type="submit" [disabled]="!form.valid" i18n>Сохранить</button>
            &nbsp;
            <button *ngIf="isModal" (click)="modalClose()" nbButton status="basic" type="button" i18n="@@Close">Закрыть</button>

            <button [routerLink]="absolutePath" nbButton status="basic" type="button" i18n *ngIf="showListButton">Отмена</button>

          </form>
        </div>
        <div class="col-lg-4 n-part-left" *ngIf="editMode">
          <app-picture [entityModel]="model" [uri]="uploadPictureUri" [pictureField]="pictureField" (pictureEvent)="pictureEvent($event)">
            <span i18n="@@BannerPictureInfo" *ngIf="pictureInfo">{{ pictureInfo }}</span>
          </app-picture>

          <app-terms
            (removeTermEvent)="removeTerm($event)"
            (insertTermEvent)="insertTerm($event)"
            [model]="model"/>
        </div>
      </div>
    </nb-card-body>

  </nb-card>
</main>
<main *ngIf="permissionDenied">
  Permission Denied
</main>
